"use client";

/**
 * `use_and_care_block` is consumed by `ProductDetailTemplate` to drive the
 * AboutTheProduct modal — never rendered as a visible content block. The
 * template filters it out of `remainingBlocks` before passing them to
 * `ContentBlocksRenderer`, so this no-op exists solely so the dispatcher
 * map stays exhaustive over `CatalogContentBlockType`.
 */
export function UseAndCare(): null {
	return null;
}
